import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { REMINDER_STORAGE_READY } from '~constants/events';
import { loadFromSessionStorage, ssKeys } from '~features/storage';
import { useIsEmailConfirmed, useIsEmailConfirmRequired } from '~features/tags';
import { emailConfirmSelectors } from '~store/email-confirm';

export const useEmailConfirmDrawerBannerShow = (force: boolean): boolean => {
	const [confirmed, isConfirmedLoading] = useIsEmailConfirmed();
	const [isNewUser, isNewUserLoading] = useIsEmailConfirmRequired();

	const canShowEmailConfirm = useSelector(
		emailConfirmSelectors.getCanShowBanner
	);

	const [hide, setHide] = useState(false);
	const [wait, setWait] = useState(true);

	useEffect(() => {
		// ebana async race
		document.addEventListener(REMINDER_STORAGE_READY, ({ detail }) => {
			if (detail.ready) {
				const reminderStatus = loadFromSessionStorage<{ hide: boolean }>(
					ssKeys.NEED_HIDE_REMINDER,
					{ hide: false }
				);
				setHide(reminderStatus.hide);
				setWait(false);
			}
		});
	}, []);

	if (hide || wait) {
		return false;
	}

	return (
		!isConfirmedLoading &&
		!confirmed &&
		!isNewUserLoading &&
		!isNewUser &&
		(force || canShowEmailConfirm)
	);
};
